import React from 'react';
import { LinearProgress } from '@material-ui/core';

import { defaultEnvColor } from 'theme';

const logo = require(process.env.REACT_APP_LOGO);

const LoadingOverlay = () => {
    let backgroundColor = defaultEnvColor;

    if (process.env.REACT_APP_REGION_EXT_DEMO == 'SAR') {
        backgroundColor = '#ffd600';
    }

    return (
        <div
            id="loading-overlay"
            className="loading-overlay"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',
                zIndex: 9999999,
                backgroundColor
            }}
        >
            <img
                src={logo}
                alt={`${process.env.REACT_APP_BRAND_NAME} logo`}
                style={{
                    width: '80vw',
                    height: 'auto',
                    maxHeight: '250px',
                    maxWidth: '250px',
                    marginBottom: '16px'
                }}
            />
            <LinearProgress style={{ color: 'white', width: '60vw', maxWidth: '150px', marginBottom: '50vh' }} />
        </div>
    );
};

export default LoadingOverlay;
